import { useIntl } from 'react-intl'

import EmptyStateImage from 'app/assets/images/products/products-empty.svg'
import EmptyState from 'app/components/common/EmptyState'

const ProductsEmptyState: RFC = () => {
  const intl = useIntl()

  return (
    <EmptyState
      image={<EmptyStateImage />}
      text={intl.formatMessage({
        defaultMessage: 'These products were not found in this store'
      })}
      contentSx={{ maxWidth: 433 }}
      hideButton
    />
  )
}

export default ProductsEmptyState
